import PropTypes from 'prop-types';
import { useMemo,useState } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import { Box, Drawer, useMediaQuery, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import MenuOpenIcon from '@mui/icons-material/MenuOpen';

// project import
import DrawerHeader from './DrawerHeader';
import DrawerContent from './DrawerContent';
import MiniDrawerStyled from './MiniDrawerStyled';
import styled from 'styled-components';

const drawerWidth = 260;
// rs 

// ==============================|| MAIN LAYOUT - DRAWER ||============================== //

const MainDrawer = ({ window, onAuthUserChanged, moduleAccess }) => {
  const [open,setOpen]=useState(true)
  const theme = useTheme();
  // const matchDownMD = useMediaQuery(theme.breakpoints.down('lg'));

  function handleDrawerToggle(){
    setOpen(!open);
  }

  // responsive drawer container
  const container = window !== undefined ? () => window().document.body : undefined;

  // header + content
  function  drawerContent() {
   
    return <DrawerContent onAuthUserChanged={onAuthUserChanged} moduleAccess={moduleAccess} open={open} />
  }
   

  // Scrollable container
  const ScrollableContent = styled.div`
    max-height: 100vh;
    overflow-y: auto;
  `;

  // Drawer header with toggle button
  const DrawerTopSection = () => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: open ? 'flex-end' : 'center',
        p: 1.5,
        borderBottom: `1px solid ${theme.palette.divider}`,
      }}
    >
     
    </Box>
  );

  return (
    <>
     
    <Box component="nav" sx={{ flexShrink: { md: 0 }, zIndex: 1300 }} aria-label="sidebar">
      {/* ✅ Desktop View (Permanent Drawer) */}
      {!open?<DrawerHeader open={open} handleOpen={handleDrawerToggle} />:<></>}
      {true ? (
        <MiniDrawerStyled variant="permanent" open={open}>
          <ScrollableContent>
            {/* Added close/open button inside drawer */}
            <DrawerTopSection />
          <DrawerHeader open={open} handleOpen={handleDrawerToggle} />
           
            {drawerContent()}
          </ScrollableContent>
        </MiniDrawerStyled>
      ) : (
        /* ✅ Mobile View (Temporary Drawer) */
        <Drawer
          container={container}
          variant="temporary"
          open={open}
          onClose={handleDrawerToggle}
          ModalProps={{ keepMounted: true }}
          sx={{
            display: { xs: 'block', lg: 'none' },
            '& .MuiDrawer-paper': {
              boxSizing: 'border-box',
              width: drawerWidth,
              borderRight: `1px solid ${theme.palette.divider}`,
              backgroundImage: 'none',
              boxShadow: 'inherit',
            },
          }}
        >
          <ScrollableContent>
            {/* Added close button inside temporary drawer */}
            <DrawerTopSection />
            <DrawerHeader open={open} />
            {drawerContent()}
          </ScrollableContent>
        </Drawer>
      )}
    </Box>
    </>
  );
};

MainDrawer.propTypes = {
  
  window: PropTypes.object,
  onAuthUserChanged: PropTypes.func,
  moduleAccess: PropTypes.any,
};

export default MainDrawer;
